/** ListItem Elements
    @readonly
    @enum {string}
*/
export var LISTITEMELEMENT;
(function (LISTITEMELEMENT) {
    LISTITEMELEMENT["LI"] = "LI";
    LISTITEMELEMENT["DT"] = "DT";
    LISTITEMELEMENT["DD"] = "DD";
})(LISTITEMELEMENT || (LISTITEMELEMENT = {}));
;
